import React from 'react';
import styled from 'styled-components';
type Props = {
  data: string;
  onClick?: () => void;
  active?: boolean;
};
const Time = ({ data, onClick, active }: Props) => {
  return (
    <TimeStyled onClick={onClick} className={`${active ? 'active' : ''}`}>
      <p className="time">{data}</p>
    </TimeStyled>
  );
};

export default Time;

const TimeStyled = styled.button`
width: 100%;
height: 56px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
border: 1px solid #FFF;

border-radius: 5px;
border: 1px solid #86909C;
background: #FFF;

&.active {
  border: 1px solid #148CF1;
  background: #148CF1;
  .time {
    color: #fff;
  }
}

&:hover {
  border: 1px solid #148CF1;
}

.time {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

`;